import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";
import { effectiveUiOf, findOrganization } from "@/router/reports/react-redirect";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    organization: null,
    organizations: null,
  },
  getters: {
    isInitialized: state => state.isInitialized,
    organization: state => state.organization,
    organizations: state => state.organizations,
    // Which UI this user should get in a named organization. Resolved server-side
    // (user preferredUi ?? organization defaultUi ?? "legacy") and delivered per
    // organization, so an explicit user choice always beats the org rollout default.
    //
    // Takes an organization id because the setting is per organization and the router
    // guard asks about the organization in the target route, which for a multi-org user
    // need not be the current one. Passing nothing asks about the current organization.
    // Fails closed to "legacy" while the store is empty, when the id is not one of the
    // user's organizations, or when the API omits the field.
    effectiveUiFor: state => organizationId => effectiveUiOf(organizationId ? findOrganization(state.organizations, organizationId) : state.organization),
    effectiveUi: (_, getters) => getters.effectiveUiFor(null),
  },
  mutations: {
    setOrganization: (state, payload) => (state.organization = payload),
    setOrganizations: (state, payload) => {
      state.organization = payload ? payload[0] : null;
      state.organizations = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["user/isInitialized"]);

      var user = context.rootGetters["user/user"];
      if (!user) {
        context.commit("setOrganizations", null);
        return;
      }

      await axios
        .get(`/v1/users/${user.id}/organizations`)
        .then(res => context.commit("setOrganizations", res.data))
        .catch(() => context.commit("setOrganizations", null));
    },
  },
};
